import React from 'react';

import Chip, { ChipProps } from 'app/ui-kit/components/Chip';
import ProtectedData, { isProtectedData, Primitive, ProtectedDataProps } from 'pages/components/ProtectedData';

interface Props extends Omit<ChipProps, 'label'> {
    data: Primitive;
    href?: string;
    label: ChipProps['label'] | ProtectedDataProps['children'];
}

const ProtectedChip: React.FC<Props> = ({ data, label, href, tooltip, onClick, clickable, ...props }) => {
    const isProtected = isProtectedData(data);
    return (
        <Chip
            {...props}
            {...(href
                ? {
                      component: 'a',
                      href,
                      target: '_blank',
                      rel: 'nofollow noreferrer noopener'
                  }
                : {})}
            clickable={isProtected ? false : !!clickable || !!onClick || !!href}
            label={<ProtectedData data={data}>{label}</ProtectedData>}
            onClick={isProtected ? undefined : onClick}
            tooltip={isProtected ? undefined : tooltip}
        />
    );
};

export default ProtectedChip;
